import { render, staticRenderFns } from "./SalesGraph.vue?vue&type=template&id=1a292196&scoped=true&"
import script from "./SalesGraph.vue?vue&type=script&lang=js&"
export * from "./SalesGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a292196",
  null
  
)

export default component.exports